import { TBootsColor } from "../../../Interfaces/Utils/Style/StyleInterfaces";
import SpinnerComponent from "../../Loding/Spinner";
import { Spinner } from "../../Loding/SpinnerPadrao";
import SpinnerUAU from "../../Loding/SpinnerUAU";

interface IOrSpinnerProps {
    loading: boolean;
    children: React.ReactNode;
    spinner?: "default" | "capys" | "erp";
    loadingSize?: "lg" | "sm" | "xl";
    loadingColor?: TBootsColor;
    wrapperLoadingClasses?: string;
}

export default function OrSpinner(props: IOrSpinnerProps) {
    const spinner =
        props.spinner === "capys" ? (
            <SpinnerComponent />
        ) : props.spinner === "erp" ? (
            <SpinnerUAU />
        ) : (
            <Spinner size={props.loadingSize} color={props.loadingColor} />
        );

    const renderSpinner = props.wrapperLoadingClasses ? (
        <span className={props.wrapperLoadingClasses}>{spinner}</span>
    ) : (
        spinner
    );
    return <>{props.loading ? renderSpinner : props.children}</>;
}
